import axios from "axios";
import { encryptData, decryptData } from "../utils/encryption";

const TRANS_URL = process.env.REACT_APP_TRANSACTION_API_URL;

export async function getEnquiriesForFinalize() {
    const response = await axios
        .get(TRANS_URL + "/finalizebid/getenquiriesforfinalize")
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: [] };
        });
    return response.data;
}

export async function getComparisonSheetData(enquiryNumber) {
    let url = `${TRANS_URL}/finalizebid/getcomparisonsheet`
    const response = await axios
        .post(url, enquiryNumber)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: { enquiryData: null, customers: [] } };
        });
    return response.data;
}

export const extendDueDate = async (requestData) => {
    let url = `${TRANS_URL}/finalizebid/extendduedate`;

    // Encrypt sensitive data before sending
    const encryptedData = { ...requestData };
    if (encryptedData.CustomersData && Array.isArray(encryptedData.CustomersData)) {
        encryptedData.CustomersData = encryptedData.CustomersData.map(customer => ({
            CustomerEmail: encryptData(customer.CustomerEmail),
            CustomerCode: customer.CustomerCode
        }));
    }

    const response = await axios
        .post(url, encryptedData)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: { message: "Unable to extend due date", status: false } };
        });
    console.log("extendDueDate response",response);
    return response.data;
};

export const addCustomerToEnquiry = async (requestData) => {
    let url = `${TRANS_URL}/finalizebid/addcustomer`;

    // Encrypt sensitive customer data before sending
    const encryptedData = { ...requestData };
    
    // Handle both single customer and multiple customers
    if (encryptedData.CustomerData) {
        // Single customer (backward compatibility)
        if (encryptedData.CustomerData.CustomerEmail) {
            encryptedData.CustomerData.CustomerEmail = encryptData(encryptedData.CustomerData.CustomerEmail);
        }
        if (encryptedData.CustomerData.CustomerUserName) {
            encryptedData.CustomerData.CustomerUserName = encryptData(encryptedData.CustomerData.CustomerUserName);
        }
    } else if (encryptedData.CustomersData && Array.isArray(encryptedData.CustomersData)) {
        // Multiple customers
        encryptedData.CustomersData = encryptedData.CustomersData.map(customer => {
            const encryptedCustomer = { ...customer };
            if (encryptedCustomer.CustomerEmail) {
                encryptedCustomer.CustomerEmail = encryptData(encryptedCustomer.CustomerEmail);
            }
            if (encryptedCustomer.CustomerUserName) {
                encryptedCustomer.CustomerUserName = encryptData(encryptedCustomer.CustomerUserName);
            }
            return encryptedCustomer;
        });
    }

    const response = await axios
        .post(url, encryptedData)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: { message: "Unable to add customer", status: false } };
        });
    return response.data;
};

export const freezeEnquiry = async (requestData) => {
    let url = `${TRANS_URL}/finalizebid/freezeenquiry`;

    // Encrypt sensitive data before sending
    const encryptedData = { ...requestData };
    if (encryptedData.Remarks) {
        encryptedData.Remarks = encryptData(encryptedData.Remarks);
    }

    const response = await axios
        .post(url, encryptedData)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: { message: "Unable to freeze enquiry", status: false } };
        });
    return response.data;
};

export const rejectEnquiry = async (requestData) => {
    let url = `${TRANS_URL}/finalizebid/rejectenquiry`;

    const response = await axios
        .post(url, requestData)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: { message: "Unable to reject enquiry", status: false } };
        });
    return response.data;
};

export const withdrawBidder = async (requestData) => {
    let url = `${TRANS_URL}/finalizebid/withdrawbidder`;

    // Encrypt sensitive data before sending
    const encryptedData = { ...requestData };
    if (encryptedData.CustomerEmail) {
        encryptedData.CustomerEmail = encryptData(encryptedData.CustomerEmail);
    }
    if (encryptedData.WithdrawReason) {
        encryptedData.WithdrawReason = encryptData(encryptedData.WithdrawReason);
    }

    const response = await axios
        .post(url, encryptedData)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: { message: "Unable to withdraw bidder", status: false } };
        });
    return response.data;
};

export const updateCustomerRemarks = async (requestData) => {
    let url = `${TRANS_URL}/finalizebid/updateremarks`;

    // Encrypt sensitive data before sending
    const encryptedData = { ...requestData };
    if (encryptedData.CustomerEmail) {
        encryptedData.CustomerEmail = encryptData(encryptedData.CustomerEmail);
    }
    if (encryptedData.Remarks) {
        encryptedData.Remarks = encryptData(encryptedData.Remarks);
    }

    const response = await axios
        .post(url, encryptedData)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: { message: "Unable to update remarks", status: false } };
        });
    return response.data;
};